import * as React from 'react';
import { observer } from 'mobx-react';
import { FormField } from './form-field';
import { Textbox, ITextboxCommonProps } from '../primitives/textbox';
import { inputPropsToShowNumericKeyboard } from '../../Shared/utils/input-utils';

export type IFormControlNumberProps = ITextboxCommonProps & { formField: FormField<number | null>, 	min?: number };

@observer
export class FormControlNumber extends React.Component<IFormControlNumberProps, {}> {
	render() {
		const { formField: { value, revalidate, hasValidationError }, ...rest } = this.props;
		return (
			<Textbox {...rest}
				value={`${value}`}
				onChange={this.handleChange}
				onBlur={revalidate}
				{...inputPropsToShowNumericKeyboard() }
				aria-invalid={hasValidationError}
				type="number" />
		);
	}

	handleChange = (value: string) => {
		const { formField, maxLength } = this.props;

		if (maxLength && value.length > maxLength) {
			return;
		}

		if (!value) {
			formField.updateValue(null);
		} else {
			formField.updateValue(Number(value));
		}

	}
}
